module.exports = __webpack_public_path__ + "static/media/Societe-Pilotage-Projet-Immobilier-Vaud.02f2c41d.jpg";